import AdGenerater from '../ads/AdGenerater.js';
import SliderWithTitle from '../carousel/SliderWithTitle.js';
import Myvod from '../../pc/myvod/MyVod.js';

export default function AdSlider (props) {
  const JWTCheck = props.jwt_check;
  let areaId; // top, middle, bottom
  let adGeneraterVisibleCheck = false;

  if (props.ord_no === 1) {
    areaId = 'top';
    adGeneraterVisibleCheck = true;
  } else if (props.ord_no === 7) {
    areaId = 'middle';
    adGeneraterVisibleCheck = true;
  }

  return (
    <div>
      {/* jwt토큰이 있을시 내가본 프로그램 노출 */}
      {props.list_code === 'my_prg' && JWTCheck === true && (<Myvod title={props.title} />)}
      {adGeneraterVisibleCheck === true && <AdGenerater id={areaId} />}
      {props.list_code !== 'my_prg' && (
        <SliderWithTitle
          slide_key={props.slide_key}
          title={props.title}
          desc={props.desc}
          link={props.link}
          type={props.type}
          data={props.data}
          relate_id={props.relate_id}
          relate_title={props.relate_title}
          relate_title_view_yn={props.relate_title_view_yn}
          relate_type={props.relate_type}
          bottom_type={props.bottom_type}
          ord_no={props.ord_no}
          clickParams={props.clickParams}
        />
      )}
    </div>
  );
}
